import * as yup from 'yup';

export const IncomingDataPageModalSchema = yup.object().shape({
    Action: yup.number().nullable().required('An Applicable Action is required').typeError('An Applicable Action is required'),
    
  });
